// @ts-expect-error
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import computeMd5 from "blueimp-md5";
import * as FileSystem from "expo-file-system/legacy";
import { Platform } from "react-native";
import Sentry from "../sentry";
export function getCachedUri(uri) {
    if (Platform.OS === 'web' || typeof uri === 'number') return null;
    var extension = uri.split('.').reverse()[0];
    var hash = computeMd5(uri);
    return "".concat(FileSystem.documentDirectory, "mediaplayer-preload/").concat(hash, ".").concat(extension);
}
export var getMinuteSecondFromMillis = function(millis) {
    var totalSeconds = millis / 1000;
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = Math.floor(totalSeconds % 60);
    return {
        minutes: minutes,
        seconds: seconds
    };
};
// Adapted from
// https://github.com/ihmpavel/expo-video-player/blob/3448d17d0773f967082b194453742ebc2f6f88f9/lib/index.tsx#L433
export var getMMSSFromMillis = function(millis, duration) {
    var _getMinuteSecondFromMillis = getMinuteSecondFromMillis(millis), minutes = _getMinuteSecondFromMillis.minutes, seconds = _getMinuteSecondFromMillis.seconds;
    var durationLongerThanTenMinutes = duration / 1000 / 60 >= 10;
    var padWithZero = function(n, isMinuteValue) {
        var str = n.toString();
        if (!isMinuteValue && n < 10 || n < 10 && durationLongerThanTenMinutes) {
            return '0' + str;
        }
        return str;
    };
    return padWithZero(minutes, true) + ':' + padWithZero(seconds, false);
};
export function preloadMedia(uri) {
    return _preloadMedia.apply(this, arguments);
}
function _preloadMedia() {
    _preloadMedia = _async_to_generator(function(uri) {
        var cachedUri, exists, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (Platform.OS === 'web') return [
                        2
                    ];
                    return [
                        4,
                        FileSystem.makeDirectoryAsync("".concat(FileSystem.documentDirectory, "mediaplayer-preload"), {
                            intermediates: true
                        })
                    ];
                case 1:
                    _state.sent();
                    cachedUri = getCachedUri(uri);
                    return [
                        4,
                        FileSystem.getInfoAsync(cachedUri)
                    ];
                case 2:
                    exists = _state.sent().exists;
                    if (!!exists) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        FileSystem.downloadAsync(uri, cachedUri)
                    ];
                case 3:
                    result = _state.sent();
                    Sentry.addBreadcrumb({
                        message: 'preloadMedia',
                        data: result
                    });
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _preloadMedia.apply(this, arguments);
}
